import styled, {css} from "styled-components"

import Flex from "../Flex"
import Input from "../FormItem/Input"

interface StyledChipProps {
  readOnly?: boolean
}

export const StyledInput = styled(Input)`
  ${({theme}) => css`
    .input-group {
      margin-top: 0px;
    }
    .form-control {
      min-width: 250px;
      height: ${theme.spacing.six};
      line-height: ${theme.spacing.six};
      border-radius: ${theme.spacing.three};
      padding: ${theme.spacing.oneAndHalf} ${theme.spacing.two};
      color:  ${theme.colors.filterChip};
      font-size: ${theme.spacing.two};
      font-weight: 600;
    }
    .input-group-addon {
      border-top-right-radius: ${theme.spacing.three};
      border-bottom-right-radius: ${theme.spacing.three};
    }
  `}
`
export const Chip = styled(Flex)<StyledChipProps>`
  ${({theme}) => css`
    height: ${theme.spacing.six};
    line-heght: ${theme.spacing.six};
    padding: ${theme.spacing.oneAndHalf} ${theme.spacing.three};
    color: ${theme.colors.filterChip};
    background: ${({readOnly}) => readOnly ? theme.colors.greys.light : theme.colors.greys.mediumLight};
    border-radius: ${theme.spacing.three};
  `}
`
